import { Flex, Spin } from "antd";
import styled from "styled-components";

export const OrgManagerWrap = styled(Flex)`
height: 100%; 
> .left,
> .right {
  height: 100%;
}

> .left {
  padding: 20px 20px 20px 0;
  max-height: 90vh;
  width: 30%;
}

> .left .left-tree {
    height: 96%;
    padding: 4px 10px;
    border: 2px solid #dfdfdfe0;
    overflow-y: auto;
    overflow-x: hidden;
  }

> .right {
  flex: 1;
  min-width: 40%;
  max-height: 90%;
  // border: 2px solid #dfdfdfe0;
  // margin-left: 20px;
  padding: 0 20px;
  // overflow-y: auto;
  // overflow-x: hidden;
}
  > .right .table--wrap {
    flex-grow: 1;
    height: 100%;
    margin-bottom: 20px;
  }
    > .right .table-avatar{
      cursor: default;
    }

  .spin-style{
    height: 96%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`